import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {FieldGroup} from "../FieldGroup";

class TableSelection extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const { settings, action } = this.props;

		return (
				<FieldGroupContext.Consumer>

					{({ endpointId, endpoint, currentItem, action }) => (

						<React.Fragment>
							<h3>Table Selection</h3>

							<p>Select a database table:</p>

							<React.Fragment>
								<FieldGroup label="" fields={settings.endpoints[endpointId][action][0].tableSelection[0].fields} group="tableSelection" groupId={0} currentItem={currentItem} action={action}/>
							</React.Fragment>

						</React.Fragment>
					)}

				</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(TableSelection);
